// context/DataContext.js
import { createContext, useContext, useEffect, useState } from "react";
import { fetchBlogById, fetchBlogs } from "@/hooks/useBlog";
import { fetchProjectById, fetchProjects } from "@/hooks/useProject";
import { fetchFeatureTestimonials, fetchTestimonials } from "@/hooks/useTestimonials";
import { fetchCertifications, fetchCertificationById } from "@/hooks/useCertification";

const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [blogs, setBlogs] = useState([]);
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // const [projectDetails, setProjectDetails] = useState([])
  const [testimonials, setTestimonials] = useState([]);
  const [testimonialsFeature, setTestimonialsFeature] = useState([]);
  const [certifications, setCertifications] = useState([]);

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true); // start loading
        const blogsRes = await fetchBlogs();
        const projectsRes = await fetchProjects();
        const testimonialsRes = await fetchTestimonials();

        setBlogs(blogsRes.blogs || blogsRes);
        setProjects(projectsRes.projects || projectsRes);
        setTestimonials(testimonialsRes?.testimonial);

        try {
          const certificationsRes = await fetchCertifications();
          setCertifications(certificationsRes?.certifications || certificationsRes || []);
        } catch {
          setCertifications([]);
        }
      } catch (err) {
        setError(err.message || "Failed to fetch data");
      } finally {
        setLoading(false); // stop loading after fetch
      }
    };
    loadData();
  }, []);

  const getProjectById = async (id) => {
    const res = await fetchProjectById(id);
    return res?.project || null;
  };
  const getBlogById = async (id) => {
    const res = await fetchBlogById(id);
    // console.log(res.blog)
    return res?.blog || null;
  };

  const getCertificationById = async (id) => {
    const res = await fetchCertificationById(id);
    return res?.certification || null;
  };

  return (
    <DataContext.Provider value={{ blogs, projects, testimonials, certifications, getProjectById, getBlogById, getCertificationById, loading, error }}>
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => useContext(DataContext);

